"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PronunciationDictionaryVersionResponseModelPermissionOnResource = void 0;
exports.PronunciationDictionaryVersionResponseModelPermissionOnResource = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
